import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  bottom: 0;
  top: 48px;
  z-index: 1;
  background: var(--document-background);
  border-radius: 0px 15px 0px 0px;
  overflow-y: auto;
  color: var(--grey-0);
  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: var(--scrollbar-track);
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--scrollbar-thumb);
    border-radius: 5px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: var(--scrollbar-thumb-hover);
  }

  &.sw2 {
    overflow-y: visible;
    height: fit-content;
  }

  &.left-bar-collapsed {
    border-radius: 0px 15px 0px 15px;
  }

  #commander {
    width: calc(100% - 80px);
    margin: 40px auto;

    h2 {
      font-size: 22px;
      margin-bottom: 16px;
    }

    h3 {
      font-size: 18px;
      margin-bottom: 10px;
    }

    a {
      &.commander-back {
        color: var(--grey-2);
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(-10px, 10px);
        padding: 5px 10px;
        font-size: 14px;
      }
    }
  }

  .commander__form {
    display: flex;
    flex-flow: column nowrap;
  }

  .commander__submit-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 15px;
    margin-bottom: 30px;

    .icon-wrapper {
      display: flex;
      align-items: center;
      gap: 5px;
    }

    p {
      max-width: 400px;
      font-family: "Inter";
      font-weight: 500;
      line-height: 130% !important;
      font-size: 14px;
      color: var(--grey-1);
      a {
        color: var(--grey-1);
        text-decoration: underline;
      }
    }
    svg {
      path {
        fill: var(--cta-text-color);
      }
      border: 2px solid rgba(255, 255, 255, 0.4);
      border-radius: 3px;
    }
  }

  .commander__example {
    margin-bottom: 20px;
  }

  .commander__example-action {
    color: var(--grey-1);
    text-decoration: underline;
  }

  textarea {
    border-radius: 5px;
    padding: 10px;
    font-family: "Roboto", sans-serif;
    font-size: 16px;
    resize: none;
    background: transparent;
    color: var(--grey-0);
    border: 1.5px solid var(--grey-2);
    outline: 3px solid transparent;
    display: block;
    width: calc(100% - 24px);
    ::selection {
      background: var(--text-highlight);
    }

    &:focus {
      border: 1.5px solid transparent;
      outline: 3px solid var(--primary-cta-hover);
    }
  }

  .commander__submit-button {
    border-radius: 10px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
    padding-left: 11px !important;
    padding-right: 11px !important;
    font-size: 17.6px !important;
    margin-top: 0 !important;
  }

  button:disabled {
    background-color: var(--button-disabled) !important;
    cursor: default !important;
    color: var(--button-disabled-color) !important;
  }

  .commander__submit-spinner {
    width: 30px;
    height: 30px;
    margin: 0 10px 0px auto;
    align-self: center;
  }
`;
